import { Formik, FormikProps } from "formik";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useSearchParams } from 'react-router-dom';
import AGSelect from "../../../components/AgSelect";
import AGButtonV2 from "../../../components/ButtonV2";
import Card from "../../../components/Card";
import AGCheckbox from "../../../components/Checkbox";
import NotificationModal from "../../../components/NotificationModal";
import PageInfiniteScroll from "../../../components/PageInfiniteScroll";
import { useUserMappingRoles } from "../../../hook/useUserMappingRoles";
import {
    AgnetRegion,
    ComMainService,
    SearchSecondmentDataRes,
    SecondaryInterestType
} from "../../../models";
import { UserContext } from "../../../Provider";
import { httpGET, httpPOST } from "../../../utils/ajaxHelper";
import { hasSearchParams } from "../../../utils/checkParams";
import { KEY_ITEM_LOCALSTORAGE, OFFERING_TYPE } from "../../../utils/constant";
import { compare } from "../../../utils/sort";
import FormMessageModal from "../formMessageModal";
import { TypeSentTo } from "../formMessageModal/formMessageModal.props";
import NavigateTabs from "../navigateTab";
import { tabDatas } from "../navigateTab/navigateTab.data";
import { CustomButtonSearch, MainComSearch } from "../searchItem.styled";
import { ServiceItemType } from "../searchService.props";
import { CheckBoxWrap, Container, HeadGrButton, Line, MobileSearch, SearchBlock } from "../searchSevices.styled";
import { SearchItemV2 } from "../serviceItem";
import { IFirmNameSearch } from "../tabsSearchFirm/tabsSearchFirm.props";
import Tooltip from "../../../components/Tooltip";
import { TextTooltipInterestType } from "./textTooltip";

export const SearchSecondmentTab = () => {
    const [page, setPage] = useState<number>(1);
    const [maxLength, setMaxLength] = useState<number>(1);
    const [comMainService, setComMainService] = useState<ComMainService[]>();
    const [agnetRegion, setAgnetRegion] = useState<AgnetRegion[]>();
    const formRef = useRef<FormikProps<any>>(null);
    const [selectedRecords, setSelectedRecords] = useState<SearchSecondmentDataRes[]>([]);
    const [data, setData] = useState<SearchSecondmentDataRes[]>();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [openMobileMenu, setOpenMobileMenu] = useState<boolean>(false);
    const isMobileScreen = screenWidth < 769;
    const [isShowSendMessage, setIsShowSendMessage] = useState<boolean>(false);
    const [isShowNotification, setIsShowNotification] = useState<"form1" | "form2" | undefined>();
    const [searchParams] = useSearchParams();
    const [searchParamData, setSearchParamData] = useState<any>();
    const [searchParamResetData, setSearchParamResetData] = useState<any>({});
    const [notificationMessage, setNotificationMessage] = useState<any | undefined>();
    const [, setShowCompareButton] = useState<boolean>(false);
    const [, setURLCompareService] = useState<string>("");
    const [handleMappingRoles,] = useUserMappingRoles();
    const [firmName, setFirmName] = useState<IFirmNameSearch[]>([]);
    const [secondaryInterestType, setSecondaryInterestType] = useState<SecondaryInterestType[]>();
    const [initalValues, setInitalValues] = useState<any>();
    const navigate = useNavigate();
    const user = useContext(UserContext);
    const keySearch = ["firmNames", "mainServiceId", "region", "withoutServices", "interestType"];
    const resetClearForm = {
        isUserSearch: false,
        mainServiceId: [],
        interestType: [],
        firmNames: [],
        region: [],
        withoutServices: false
    }


    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const { mutate: getComMainServices } = useMutation(
        () =>
            httpGET({
                url: "/ComMainService",
                params: { type: "SECONDMENT" }
            }),
        {
            onSuccess: (rs) => {
                setComMainService(rs as ComMainService[]);
            },
        },
    );

    const { mutate: getAllFirmName } = useMutation(
        (par: { withoutServices: boolean }) =>
            httpGET({
                url: "/firm/get-firm-name-search-service",
                params: { ...par, offeringType: OFFERING_TYPE.SECONDMENT, pageType: "secondment" }
            }),
        {
            onSuccess: (rs) => {
                setFirmName(rs)
            },
        },
    );

    const { mutate: getAgnetRegion } = useMutation(
        (firmId: number | undefined) =>
            httpGET({
                url: "/agnetregion",
                params: { firmId: firmId },
            }),
        {
            onSuccess: (rs) => {
                setAgnetRegion(rs as AgnetRegion[]);
            },
        },
    );

    const { mutate: getSecondaryInterestType } = useMutation(
        () =>
            httpGET({
                url: "/ComMainService/secondary-interest-type",
            }),
        {
            onSuccess: (rs: SecondaryInterestType[]) => {
                setSecondaryInterestType(rs)
            },
        },
    );

    const { mutate: search } = useMutation(
        (data: any) =>
            httpPOST({
                url: "/CommerceFirmData/search-secondment",
                data: data,
            }),
        {
            onSuccess: (rs, { page }) => {
                if (rs) {
                    if (page === 1) {
                        setData(rs.data);
                    } else {
                        setData([
                            ...data ?? [],
                            ...rs.data,
                        ]);
                    }
                    setMaxLength(rs.maxLength);
                }
                setSelectedRecords([]);
            },
        },
    );

    useEffect(() => {
        getComMainServices();
        getAgnetRegion(undefined);
        getSecondaryInterestType()
    }, [getSecondaryInterestType, getAllFirmName, getComMainServices, getAgnetRegion, search]);

    useLayoutEffect(() => {
        let isShow = false;

        if (selectedRecords && selectedRecords.length > 1) {
            const rs = selectedRecords.map(data => (
                {
                    firmId: data.firmID,
                    serviceIds: [...new Set(data.services?.flatMap(se => se.tblComFirmPracticeLevels?.map(co => co.fkSecondaryService?.fkMainServiceId)) ?? [])]
                }
            ))

            const serviceIdCommon = rs.filter(e => e.serviceIds.length)
                .reduce((acc, curr) => acc.filter(value => value && curr.serviceIds.some(cr => cr === value)), rs[0].serviceIds).join("_");
            const firmId = rs.map(e => e.firmId).join("_");

            if (serviceIdCommon && serviceIdCommon.length) isShow = true

            setURLCompareService(`/compare-service?firms=${firmId}&mainServices=${serviceIdCommon}`)

            localStorage.setItem(KEY_ITEM_LOCALSTORAGE.SELECTED_RECORD_COMPARE_SERVICE, JSON.stringify({
                isCompareService: false,
                firms: rs.map(e => e.firmId)
            }))
        }

        setShowCompareButton(isShow)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRecords])

    useEffect(() => {
        if (comMainService && agnetRegion && !data) {
            const params: { [key: string]: string } = {};
            for (const [key, value] of searchParams.entries()) {
                params[key] = value;
            }

            getAllFirmName({
                withoutServices: params.withoutServices === "true"
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comMainService, agnetRegion]);

    const handleSearchLoading = () => {
        if (comMainService && agnetRegion && !data) {
            const params: { [key: string]: string } = {};
            for (const [key, value] of searchParams.entries()) {
                params[key] = value;
            }

            const firmNameData = params.firmNames
                ? params.firmNames
                    .split(",")
                    .map((e) => Number(e))
                    .filter(e => firmName.map(s => s.orgId).includes(e))
                    .map((e) => {
                        return {
                            label: firmName?.find(
                                (f) => f.orgId === e,
                            )?.orgName,
                            value: e,
                        };
                    })
                : []

            const dataSetting = {
                ...params,
                firmNames: firmNameData,
                mainServiceId: params.mainServiceId
                    ? params.mainServiceId
                        .split(",")
                        .map((e) => Number(e))
                        .map((e) => {
                            return {
                                value: e,
                                label: comMainService?.find(
                                    (f) => f.mainServiceId === e,
                                )?.mainServiceName,
                            };
                        })
                    : [],
                region: params.region
                    ? params.region
                        .split(",")
                        .map((e) => Number(e))
                        .map((e) => {
                            return {
                                label: agnetRegion?.find(
                                    (f) => f.netRegionId === e,
                                )?.netRegionName,
                                value: e,
                            };
                        })
                    : [],
                interestType: params.interestType
                    ? params.interestType
                        .split(",")
                        .map((e) => Number(e))
                        .map((e) => {
                            return {
                                label: secondaryInterestType?.find(
                                    (f) => f.secondmentInterestTypeId === e,
                                )?.secondmentInterestType,
                                value: e,
                            };
                        })
                    : [],
                withoutServices: params.withoutServices === "true"
            };
            setInitalValues(dataSetting);
            setSearchParamData(dataSetting);

            search({
                ...params,
                firmNames: params.firmNames
                    ? firmNameData.map((e) => e.value)
                    : [],
                mainServiceId: params.mainServiceId
                    ? params.mainServiceId.split(",").map((e) => Number(e))
                    : [],
                secondaryServiceId: params.secondaryServiceId
                    ? params.secondaryServiceId.split(",").map((e) => Number(e))
                    : [],
                region: params.region
                    ? params.region.split(",").map((e) => Number(e))
                    : [],
                withoutServices: params.withoutServices === "true",
                offeringType: OFFERING_TYPE.SECONDMENT,
                interestType: params.interestType
                    ? firmNameData.map((e) => e.value)
                    : [],
                page: 1
            });
        }
    }

    useEffect(() => {
        if (firmName) {
            handleSearchLoading()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firmName])

    const { mutate: getRecipients } = useMutation(
        ({ ids, sendTo }: { ids: string; sendTo: TypeSentTo }) =>
            httpGET({
                url: `/SendMessage/recipient?reqIds=${ids}&action=${sendTo}`,
            }),
        {
            onSuccess: (rs) => {
                setIsShowSendMessage(true);
            },
        },
    );

    if (!comMainService || !agnetRegion || !initalValues) {
        return null;
    }

    const checkActionSendTo = (): "Firm" | "Service" => {
        if (
            searchParamData &&
            ((searchParamData.mainServiceId && searchParamData.mainServiceId.length !== 0)
                || (searchParamData.interestType && searchParamData.interestType.length !== 0))
        ) {
            return "Service";
        }

        return "Firm";
    };

    const checkReceipientsMessage = () => {
        const sendTo = checkActionSendTo();

        let ids = {
            Firm: selectedRecords.map((d) => d.firmID).join(","),
            Service: selectedRecords
                .map((d) => d.services?.map((e) => e.comOfferingId).join(","))
                .join(","),
        }[sendTo];

        getRecipients({
            ids,
            sendTo,
        });
    };

    const apiCall = (values: any, page: number) => {
        const data = {
            ...values,
            firmNames: values?.firmNames?.map((e: any) => Number(e.value)),
            mainServiceId: values?.mainServiceId?.map((e: any) => e.value),
            region: values?.region?.map((e: any) => e.value),
            offeringType: OFFERING_TYPE.SECONDMENT,
            interestType: values?.interestType?.map((e: any) => Number(e.value)),
            page
        }

        const queryParams = new URLSearchParams(data);
        const url = `?${queryParams.toString()}`;
        navigate(url);
        search(data);
        setOpenMobileMenu(false);
    };

    const onKeepAliveField = () => {
        if (!Object.keys(searchParamResetData).length) {
            formRef.current?.setValues(resetClearForm)
        }
        else {
            setSearchParamData(searchParamResetData);
            Object.entries(searchParamResetData).forEach(([key, value]) => {
                formRef.current?.setFieldValue(key, value);
            });
        }
    }

    const getSearchServiceIds = ()=>{
        return searchParamData.mainServiceId.map((x: any) => x.value);
    }

    const getSearchInterestTypeIds = ()=>{
        return searchParamData.interestType.map((x: any) => x.value);
    }

    return (
        // <SearchServices >
        <MainComSearch isMobileScreen={isMobileScreen}>
            <FormMessageModal
                isShow={isShowSendMessage}
                handleClose={() => {
                    setIsShowSendMessage(false);
                }}
                handleShowNoti={(firmNotSend) => {
                    firmNotSend && setIsShowNotification("form2");
                    setNotificationMessage(firmNotSend);
                }}
                dataFirm={selectedRecords}
                sendTo={checkActionSendTo()}
                isMultipleSendMail
                pageType="Secondment"
                getSearchServiceIds={getSearchServiceIds}
                getSearchInterestTypeIds={getSearchInterestTypeIds}
            />

            <NotificationModal
                visible={isShowNotification === "form1"}
                toggleModal={() => {
                    setIsShowNotification(undefined);
                }}>
                <h1 className="py-[10px] px-[20px]">
                    The inquiry could not be sent to{" "}
                    <b>
                        {selectedRecords
                            ? selectedRecords
                                .map((e) => e.firmName)
                                .join("; ")
                            : ""}
                    </b>{" "}
                    due to the lack of contacts for the organization. Please contact{" "}
                    {process.env.REACT_APP_CONTACT_NAME || "Natasha Schamberger"} at{" "}
                    <a
                        href={`mailto:${
                            process.env.REACT_APP_CONTACT_MAIL || "natasha@allinialglobal.com"
                        }`}                        
                        className="text-[#2c76aa]">
                       {process.env.REACT_APP_CONTACT_MAIL ||
                            "natasha@allinialglobal.com"}
                    </a>
                    / <i>{process.env.REACT_APP_CONTACT_PHONE || "+1470 567 4594"}</i> for further information.
                </h1>
            </NotificationModal>

            <NotificationModal
                visible={isShowNotification === "form2"}
                toggleModal={() => {
                    setIsShowNotification(undefined);
                }}>
                {notificationMessage}
            </NotificationModal>

            <Container>
                <div
                    className={`flex ${!isMobileScreen ? " space-x-5" : ""}`}>
                    <div className={`col-left ${isMobileScreen ? "min-w-0" : "min-w-[260px]"}`}>
                        <Card style={{ padding: "5px 0" }}>
                            {isMobileScreen ? (
                                <Formik
                                    innerRef={formRef}
                                    initialValues={initalValues}
                                    onSubmit={(values) => {
                                        setPage(1)
                                        apiCall({
                                            ...values,
                                            backTo: "search-secondments",
                                            isUserSearch: hasSearchParams(values, keySearch)
                                        }, 1);
                                        setSearchParamData({
                                            ...values,
                                            backTo: "search-secondments",
                                            isUserSearch: hasSearchParams(values, keySearch)
                                        });
                                        setSearchParamResetData({
                                            ...values,
                                            backTo: "search-secondments",
                                            isUserSearch: hasSearchParams(values, keySearch)
                                        });
                                    }}>
                                    {({
                                        values,
                                        setFieldValue,
                                        submitForm,
                                        setValues
                                    }) => {
                                        return (
                                            <MobileSearch
                                                style={{
                                                    left: openMobileMenu
                                                        ? "0"
                                                        : "-100%",
                                                }}>
                                                <div
                                                    onClick={() => {
                                                        setOpenMobileMenu(
                                                            false,
                                                        );
                                                        onKeepAliveField()
                                                    }}
                                                    className="close-button">
                                                    <CloseButton />
                                                </div>
                                                <form className="mb-[84px]">
                                                    <SearchBlock>
                                                        <label>
                                                            <div className="title">
                                                                Search by region
                                                            </div>
                                                            <AGSelect
                                                                isShowFull={true}
                                                                isClearable
                                                                isMulti
                                                                value={
                                                                    values.region
                                                                }
                                                                onChange={(
                                                                    e: any,
                                                                ) => {
                                                                    setFieldValue(
                                                                        "region",
                                                                        e,
                                                                    );
                                                                }}
                                                                options={agnetRegion
                                                                    ?.map(
                                                                        (
                                                                            e,
                                                                        ) => {
                                                                            return {
                                                                                value: e.netRegionId,
                                                                                label: e.netRegionName,
                                                                            };
                                                                        },
                                                                    )
                                                                    .sort(
                                                                        (
                                                                            a,
                                                                            b,
                                                                        ) =>
                                                                            compare(
                                                                                a,
                                                                                b,
                                                                                "label",
                                                                            ),
                                                                    )}
                                                                placeholder="Select regions"
                                                            />
                                                        </label>
                                                    </SearchBlock>
                                                    <SearchBlock>
                                                        <label>
                                                            <div className="title">
                                                                Interest type
                                                            </div>
                                                            <AGSelect
                                                                isShowFull={true}
                                                                isMulti
                                                                isClearable
                                                                options={secondaryInterestType
                                                                    ?.map(
                                                                        (
                                                                            e,
                                                                        ) => {
                                                                            return {
                                                                                value: e.secondmentInterestTypeId,
                                                                                label: e.secondmentInterestType,
                                                                            };
                                                                        },
                                                                    )}
                                                                onChange={(
                                                                    e: any,
                                                                ) => {
                                                                    setFieldValue(
                                                                        "interestType",
                                                                        e,
                                                                    );
                                                                }}
                                                                placeholder={
                                                                    "Select interest type"
                                                                }
                                                                value={
                                                                    values.interestType
                                                                }
                                                            />
                                                        </label>
                                                    </SearchBlock>
                                                    <SearchBlock>
                                                        <div>
                                                            <div className="title">
                                                                Organization name
                                                            </div>
                                                            <AGSelect
                                                                isShowFull={true}
                                                                isMulti
                                                                isClearable
                                                                value={
                                                                    values.firmNames
                                                                }
                                                                onChange={(
                                                                    e: any,
                                                                ) => {
                                                                    setFieldValue(
                                                                        "firmNames",
                                                                        e,
                                                                    );
                                                                }}
                                                                options={firmName
                                                                    ?.map(
                                                                        (e) => {
                                                                            return {
                                                                                value: e.orgId,
                                                                                label: e.orgName,
                                                                            };
                                                                        },
                                                                    )
                                                                    .sort(
                                                                        (
                                                                            a,
                                                                            b,
                                                                        ) =>
                                                                            compare(
                                                                                a,
                                                                                b,
                                                                                "label",
                                                                            ),
                                                                    )}
                                                                placeholder="Select organization names"
                                                            />

                                                        </div>
                                                    </SearchBlock>
                                                    <SearchBlock>
                                                        <label>
                                                            <div className="title">
                                                                Specialized Service
                                                            </div>
                                                            <AGSelect
                                                                isShowFull={true}
                                                                isClearable
                                                                isMulti
                                                                value={
                                                                    values.mainServiceId
                                                                }
                                                                onChange={(
                                                                    e: any,
                                                                ) => {
                                                                    setFieldValue(
                                                                        "mainServiceId",
                                                                        e,
                                                                    );
                                                                }}
                                                                options={comMainService
                                                                    ?.map(
                                                                        (
                                                                            e,
                                                                        ) => {
                                                                            return {
                                                                                value: e.mainServiceId,
                                                                                label: e.mainServiceName,
                                                                            };
                                                                        },
                                                                    )
                                                                    .sort(
                                                                        (
                                                                            a,
                                                                            b,
                                                                        ) =>
                                                                            compare(
                                                                                a,
                                                                                b,
                                                                                "label",
                                                                            ),
                                                                    )}
                                                                placeholder="Select services"
                                                            />
                                                        </label>
                                                    </SearchBlock>
                                                    {
                                                        handleMappingRoles(["Admin"])
                                                            ? (
                                                                <>
                                                                    <SearchBlock>
                                                                        <div className="pb-[2px]">
                                                                            <CheckBoxWrap>
                                                                                <AGCheckbox
                                                                                    value={
                                                                                        values.withoutServices
                                                                                    }
                                                                                    onChange={(
                                                                                        e,
                                                                                    ) => {
                                                                                        setFieldValue(
                                                                                            "withoutServices",
                                                                                            e.target.checked.toString(),
                                                                                        );
                                                                                        getAllFirmName({
                                                                                            withoutServices: e.target.checked
                                                                                        });
                                                                                    }}
                                                                                />
                                                                                Organizations without secondments
                                                                            </CheckBoxWrap>
                                                                        </div>
                                                                    </SearchBlock></>)
                                                            : null
                                                    }

                                                    {
                                                        openMobileMenu ? <CustomButtonSearch>
                                                            <SearchBlock>
                                                                <div className="center-button flex !justify-between">
                                                                    <AGButtonV2
                                                                        onClick={() => {
                                                                            setFieldValue("isUserSearch", false);
                                                                            setValues(resetClearForm);
                                                                            submitForm();
                                                                        }}
                                                                        hasHover={false}
                                                                        bgColor="#637381"
                                                                        color="#637381"
                                                                    >
                                                                        <span className="text-white">Clear filters</span>
                                                                    </AGButtonV2>
                                                                    <AGButtonV2
                                                                        onClick={() => {
                                                                            setFieldValue("isUserSearch", true);
                                                                            submitForm();
                                                                        }}
                                                                        hasHover={false}
                                                                        bgColor="#0971A2"
                                                                        color="#0971A2"
                                                                    >
                                                                        <span className="text-white">Apply filters</span>
                                                                    </AGButtonV2>

                                                                </div>
                                                            </SearchBlock>
                                                        </CustomButtonSearch> : null
                                                    }

                                                </form>
                                            </MobileSearch>
                                        );
                                    }}
                                </Formik>
                            ) : (
                                <Formik
                                    innerRef={formRef}
                                    initialValues={initalValues}
                                    onSubmit={(values) => {
                                        setPage(1)
                                        apiCall({
                                            ...values,
                                            backTo: "search-secondments",
                                            isUserSearch: hasSearchParams(values, keySearch)
                                        }, 1);
                                        setSearchParamData({
                                            ...values,
                                            backTo: "search-secondments",
                                            isUserSearch: hasSearchParams(values, keySearch)
                                        });
                                        setSearchParamResetData({
                                            ...values,
                                            backTo: "search-secondments",
                                            isUserSearch: hasSearchParams(values, keySearch)
                                        });
                                    }}>
                                    {({
                                        values,
                                        setFieldValue,
                                        submitForm,
                                        setValues
                                    }) => {
                                        return (
                                            <form>
                                                <SearchBlock>
                                                    <label>
                                                        <div className="title">
                                                            Search by region
                                                        </div>
                                                        <AGSelect
                                                            isShowFull={true}
                                                            isMulti
                                                            isClearable
                                                            value={
                                                                values.region
                                                            }
                                                            onChange={(
                                                                e: any,
                                                            ) => {
                                                                setFieldValue(
                                                                    "region",
                                                                    e,
                                                                );
                                                                submitForm()
                                                            }}
                                                            options={agnetRegion
                                                                ?.map(
                                                                    (e) => {
                                                                        return {
                                                                            value: e.netRegionId,
                                                                            label: e.netRegionName,
                                                                        };
                                                                    },
                                                                )
                                                                .sort(
                                                                    (
                                                                        a,
                                                                        b,
                                                                    ) =>
                                                                        compare(
                                                                            a,
                                                                            b,
                                                                            "label",
                                                                        ),
                                                                )}
                                                            placeholder="Select regions"
                                                        />
                                                    </label>
                                                </SearchBlock>
                                                <SearchBlock>
                                                    <label>
                                                        <div className="title">
                                                            Interest type
                                                        </div>
                                                        <AGSelect
                                                            isShowFull={true}
                                                            isMulti
                                                            isClearable
                                                            options={secondaryInterestType
                                                                ?.map(
                                                                    (
                                                                        e,
                                                                    ) => {
                                                                        return {
                                                                            value: e.secondmentInterestTypeId,
                                                                            label: e.secondmentInterestType,
                                                                        };
                                                                    },
                                                                )}
                                                            onChange={(
                                                                e: any,
                                                            ) => {
                                                                setFieldValue(
                                                                    "interestType",
                                                                    e,
                                                                );
                                                                submitForm()
                                                            }}
                                                            placeholder={
                                                                "Select interest type"
                                                            }
                                                            value={
                                                                values.interestType
                                                            }
                                                        />
                                                    </label>
                                                </SearchBlock>
                                                <SearchBlock>
                                                    <div>
                                                        <div className="title">
                                                            Organization name
                                                        </div>
                                                        <AGSelect
                                                            isShowFull={true}
                                                            isMulti
                                                            isClearable
                                                            value={
                                                                values.firmNames
                                                            }
                                                            onChange={(
                                                                e: any,
                                                            ) => {
                                                                setFieldValue(
                                                                    "firmNames",
                                                                    e,
                                                                );
                                                                submitForm();
                                                            }}
                                                            options={firmName
                                                                ?.map(
                                                                    (e) => {
                                                                        return {
                                                                            value: e.orgId,
                                                                            label: e.orgName,
                                                                        };
                                                                    },
                                                                )
                                                                .sort(
                                                                    (
                                                                        a,
                                                                        b,
                                                                    ) =>
                                                                        compare(
                                                                            a,
                                                                            b,
                                                                            "label",
                                                                        ),
                                                                )}
                                                            placeholder="Select organization names"
                                                        />

                                                    </div>
                                                </SearchBlock>
                                                <SearchBlock>
                                                    <label>
                                                        <div className="title">
                                                            Specialized Service
                                                        </div>
                                                        <AGSelect
                                                            isShowFull={true}
                                                            isClearable
                                                            isMulti
                                                            value={
                                                                values.mainServiceId
                                                            }
                                                            onChange={(
                                                                e: any,
                                                            ) => {
                                                                setFieldValue(
                                                                    "mainServiceId",
                                                                    e,
                                                                );
                                                                submitForm();
                                                            }}
                                                            options={comMainService
                                                                ?.map(
                                                                    (
                                                                        e,
                                                                    ) => {
                                                                        return {
                                                                            value: e.mainServiceId,
                                                                            label: e.mainServiceName,
                                                                        };
                                                                    },
                                                                )
                                                                .sort(
                                                                    (
                                                                        a,
                                                                        b,
                                                                    ) =>
                                                                        compare(
                                                                            a,
                                                                            b,
                                                                            "label",
                                                                        ),
                                                                )}
                                                            placeholder="Select services"
                                                        />
                                                    </label>
                                                </SearchBlock>
                                                {
                                                    handleMappingRoles(["Admin"])
                                                        ? (
                                                            <>
                                                                <Line />
                                                                <SearchBlock>
                                                                    <div className="pb-[2px]">
                                                                        <CheckBoxWrap>
                                                                            <AGCheckbox
                                                                                value={
                                                                                    values.withoutServices
                                                                                }
                                                                                onChange={(
                                                                                    e,
                                                                                ) => {
                                                                                    setFieldValue(
                                                                                        "withoutServices",
                                                                                        e.target.checked.toString(),
                                                                                    );
                                                                                    getAllFirmName({
                                                                                        withoutServices: e.target.checked
                                                                                    });
                                                                                    submitForm()
                                                                                }}
                                                                            />
                                                                            Organizations without secondments
                                                                        </CheckBoxWrap>
                                                                    </div>
                                                                </SearchBlock></>)
                                                        : null
                                                }
                                            </form>
                                        );
                                    }}
                                </Formik>
                            )}
                        </Card>
                    </div>
                    <div className="col-right">
                        <div
                            className={
                                isMobileScreen
                                    ? "fixed inset-x-0 sizeFixedMobile:top-[78px] top-[100px] z-[99999] bg-white shadow-lg  before:block before:absolute before:top-[-12px] before:z-[-2] before:bg-[#e4e4e4] before:w-full before:h-[50px]"
                                    : "custom-fixed"
                            }>
                            {
                                !isMobileScreen ?
                                    <Card style={{ padding: "5px 0", ...(screenWidth < 1024 && screenWidth > 768 ? { width: `${screenWidth - 360}px` } : {}) }} className="mb-[10px] !rounded-t-[10px] !rounded-b-[0] !p-[20px] overflow-x-auto no-scrollbar-disable">
                                        <NavigateTabs tabCurrent={tabDatas[3]} />
                                    </Card>
                                    : null
                            }

                            <Card
                                borderRadius={
                                    isMobileScreen ? false : true
                                }
                                style={{
                                    ...(screenWidth < 1024 && screenWidth > 768 ? { width: `${screenWidth - 360}px` } : {})
                                }}
                                className="!rounded-t-[0] !rounded-b-[10px]">
                                <HeadGrButton
                                    style={{
                                        justifyContent: isMobileScreen
                                            ? ""
                                            : "space-between",
                                        backgroundColor: isMobileScreen && selectedRecords.length ? "#0971A2" : "",
                                        ...(screenWidth < 1024 && screenWidth > 806
                                            ? { width: `${screenWidth - 360}px` }
                                            : {})
                                    }}
                                    className="overflow-x-auto overflow-y-hidden no-scrollbar-disable"
                                // className="mobile2:flex mobile2:flex-col mobile2:items-start "
                                >
                                    {!isMobileScreen && (
                                        <>
                                            <div className="search-count whitespace-nowrap mr-[20px] flex items-center">
                                                <p className="mr-[10px]">{maxLength} result(s) found</p>
                                                <Tooltip width="520px" place="right" text={
                                                    <>{TextTooltipInterestType()}</>
                                                } />
                                            </div>

                                            <AGButtonV2
                                                disabled={
                                                    selectedRecords.length === 0 || selectedRecords.find(x => x.firmID === user?.individual.fkOrgId) !== undefined
                                                }
                                                hasHover={selectedRecords.length > 0 && !selectedRecords.find(x => x.firmID === user?.individual.fkOrgId)}
                                                icon={
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={14}
                                                        height={14}
                                                        viewBox="0 0 20 14"
                                                        fill="none"
                                                        className="ml-[4px] group-disabled:!fill-[#0971A2] group-hover:fill-white fill-[#0971A2]"
                                                    >
                                                        <path
                                                            d="M19.9997 13.1283V0.84082L13.1016 6.98553L19.9997 13.1283Z"
                                                        />
                                                        <path
                                                            d="M11.3823 8.51525C10.6116 9.20162 9.44785 9.20162 8.67723 8.51525L7.42527 7.39941L0.561523 13.5134H19.5L12.6342 7.40138L11.3823 8.51721L11.3823 8.51525Z"
                                                        />
                                                        <path
                                                            d="M0.0605469 0.839844V13.1273L6.95865 6.98455L0.0605469 0.839844Z"
                                                        />
                                                        <path
                                                            d="M9.06004 8.08531C9.6122 8.57803 10.4462 8.57803 11.0003 8.08531L19.532 0.487305H0.52832L9.06009 8.08727L9.06004 8.08531Z"
                                                        />
                                                    </svg>
                                                }
                                                onClick={() => {
                                                    const sendTo = checkActionSendTo();
                                                    sendTo === "Firm"
                                                        ? checkReceipientsMessage()
                                                        : setIsShowSendMessage(
                                                            true,
                                                        );
                                                }}
                                            >
                                                <p className={`text-[14px] font-normal text-[#0971A2] group-hover:text-white group-disabled:!text-[#0971A2] whitespace-nowrap`}>Send Inquiry</p>
                                            </AGButtonV2>
                                        </>

                                    )}

                                    {isMobileScreen && !selectedRecords.length && (
                                        <div
                                            className="items-center overflow-x-auto flex flex-nowrap flex-row justify-start no-scrollbar-disable">
                                            <AGButtonV2
                                                onClick={() => {
                                                    setOpenMobileMenu(true);
                                                }}
                                                color="#333333"
                                                hasHover={false}
                                                icon={
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={14}
                                                        height={14}
                                                        viewBox="0 0 14 14"
                                                        fill="none"
                                                        className="  fill-[#333333]"
                                                    >
                                                        <path
                                                            d="M4.94699 0.117188C4.02615 0.117188 3.2438 0.738573 2.9902 1.59017H0.894911C0.572984 1.59017 0.342773 1.84377 0.342773 2.1657C0.342773 2.48762 0.596374 2.74122 0.918301 2.74122H3.01359C3.2438 3.59282 4.04954 4.21421 4.97038 4.21421C5.91461 4.21421 6.69696 3.59282 6.95056 2.74122H15.4449C15.7668 2.74122 16.0204 2.48762 16.0204 2.1657C16.0204 1.84377 15.7668 1.59017 15.4449 1.59017H6.95056C6.6736 0.738573 5.8912 0.117188 4.94699 0.117188ZM4.97037 1.26824C5.45418 1.26824 5.86783 1.65942 5.86783 2.1657C5.86783 2.67198 5.45326 3.06315 4.97037 3.06315C4.48656 3.06315 4.07292 2.67198 4.07292 2.1657C4.07202 1.65942 4.48658 1.26824 4.97037 1.26824Z"
                                                            fill="black"
                                                        />
                                                        <path
                                                            d="M11.8768 4.72168C10.956 4.72168 10.1736 5.34306 9.92001 6.19466H0.918301C0.572984 6.19466 0.342773 6.44826 0.342773 6.77019C0.342773 7.09212 0.596374 7.34572 0.918301 7.34572H9.92001C10.1502 8.19731 10.956 8.8187 11.8768 8.8187C12.821 8.8187 13.6034 8.19731 13.857 7.34572H15.4451C15.767 7.34572 16.0206 7.09212 16.0206 6.77019C16.0206 6.44826 15.767 6.19466 15.4451 6.19466H13.857C13.6034 5.34306 12.8201 4.72168 11.8768 4.72168ZM11.8993 5.87273C12.3831 5.87273 12.7967 6.26391 12.7967 6.77019C12.7967 7.27647 12.3822 7.66764 11.8993 7.66764C11.4155 7.66764 11.0018 7.27647 11.0018 6.77019C11.0018 6.26391 11.393 5.87273 11.8993 5.87273Z"
                                                            fill="black"
                                                        />
                                                        <path
                                                            d="M7.70952 9.78613C6.78868 9.78613 6.00633 10.4075 5.75273 11.2591H0.918301C0.572984 11.2591 0.342773 11.5127 0.342773 11.8346C0.342773 12.1566 0.596374 12.4102 0.918301 12.4102H5.77621C6.00642 13.2618 6.81216 13.8832 7.73301 13.8832C8.67724 13.8832 9.45959 13.2618 9.71319 12.4102H15.445C15.7669 12.4102 16.0205 12.1566 16.0205 11.8346C16.0205 11.5127 15.7669 11.2591 15.445 11.2591H9.68971C9.43611 10.4075 8.65376 9.78613 7.70952 9.78613ZM7.7329 10.9372C8.21671 10.9372 8.63036 11.3284 8.63036 11.8346C8.63036 12.3409 8.21579 12.7321 7.7329 12.7321C7.24909 12.7321 6.83545 12.3409 6.83545 11.8346C6.85793 11.3284 7.24911 10.9372 7.7329 10.9372Z"
                                                            fill="black"
                                                        />
                                                    </svg>
                                                }>
                                            </AGButtonV2>

                                            <NavigateTabs tabCurrent={tabDatas[3]} />
                                        </div>
                                    )}

                                    {isMobileScreen && selectedRecords.length ? (
                                        <div
                                            className="overflow-x-auto w-full flex flex-nowrap flex-row justify-between no-scrollbar-disable items-center ">
                                            <p className="text-white text-nowrap mr-[32px]">
                                                {selectedRecords.length} item(s) selected
                                            </p>

                                            <div className="flex flex-row items-center">
                                                <AGButtonV2
                                                    disabled={
                                                        selectedRecords.length === 0 || selectedRecords.find(x => x.firmID === user?.individual.fkOrgId) !== undefined
                                                    }
                                                    color="#333333"
                                                    hasHover={false}
                                                    icon={
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={14}
                                                            height={14}
                                                            viewBox="0 0 20 14"
                                                            fill="none"
                                                            className="ml-[4px] group-disabled:!fill-[#333333] fill-[#333333]"
                                                        >
                                                            <path
                                                                d="M19.9997 13.1283V0.84082L13.1016 6.98553L19.9997 13.1283Z"
                                                            />
                                                            <path
                                                                d="M11.3823 8.51525C10.6116 9.20162 9.44785 9.20162 8.67723 8.51525L7.42527 7.39941L0.561523 13.5134H19.5L12.6342 7.40138L11.3823 8.51721L11.3823 8.51525Z"
                                                            />
                                                            <path
                                                                d="M0.0605469 0.839844V13.1273L6.95865 6.98455L0.0605469 0.839844Z"
                                                            />
                                                            <path
                                                                d="M9.06004 8.08531C9.6122 8.57803 10.4462 8.57803 11.0003 8.08531L19.532 0.487305H0.52832L9.06009 8.08727L9.06004 8.08531Z"
                                                            />
                                                        </svg>
                                                    }
                                                    onClick={() => {
                                                        const sendTo = checkActionSendTo();
                                                        sendTo === "Firm"
                                                            ? checkReceipientsMessage()
                                                            : setIsShowSendMessage(
                                                                true,
                                                            );
                                                    }}
                                                >
                                                    <p className={`text-nowrap text-[14px] font-normal text-[#333333] group-disabled:!text-[#333333]`}>Send Inquiry</p>
                                                </AGButtonV2>
                                            </div>

                                        </div>
                                    ) : null}

                                </HeadGrButton>
                            </Card>
                        </div>

                        {isMobileScreen && (
                            <Card
                                borderRadius={isMobileScreen ? false : true}
                                className="my-[10px] px-[20px] py-[10px] text-[14px]">
                                <div className="search-count flex items-center">
                                    <p className="mr-[10px]">{maxLength} result(s) found</p>
                                    <Tooltip width="" text={
                                        <>{TextTooltipInterestType(false)}</>
                                    } />
                                </div>
                            </Card>
                        )}
                        <Card
                            style={{ marginTop: 10, backgroundColor: "transparent" }}
                            borderRadius={isMobileScreen ? false : true}>
                            {
                                data && <PageInfiniteScroll
                                    items={data ?? []}
                                    hasMore={data ? data.length < (maxLength as number) : false}
                                    loadMore={() => {
                                        const newPage = page + 1;
                                        apiCall(searchParamData, newPage);
                                        setPage(newPage);
                                    }}
                                    onItemSelect={(checked, e) => {
                                        if (checked) {
                                            setSelectedRecords([
                                                ...selectedRecords,
                                                e,
                                            ]);
                                        } else {
                                            setSelectedRecords(
                                                selectedRecords.filter(
                                                    (f) =>
                                                        f.firmID !==
                                                        e.firmID,
                                                ),
                                            );
                                        }
                                    }}
                                    renderItem={
                                        (e, index, onClick, onSelect) => (
                                            <SearchItemV2
                                                tabType={ServiceItemType.SECONDMENT}
                                                isMobileDevice={
                                                    isMobileScreen
                                                }
                                                hasTag={e.isSponsor && e.services?.some(t => t.sponsorMessage)}
                                                isVendor={e.isVendor}
                                                onSelect={(checked) => onSelect?.(checked)}
                                                key={index}
                                                data={e}
                                                checked={selectedRecords.some(
                                                    (f) =>
                                                        f.firmID ===
                                                        e.firmID,
                                                )}
                                                selectedRecords={selectedRecords}
                                                onSaveHistory={(e) => {
                                                    localStorage.setItem(KEY_ITEM_LOCALSTORAGE.REDIRECT_URL_COMPARE_SERVICE, window.location.href);
                                                }}
                                            />)
                                    }
                                />
                            }
                            {/* {data
                                ?.map((e, index) => {
                                    return (
                                        <>
                                            <SearchItemV2
                                                tabType={ServiceItemType.PRODUCT}
                                                isMobileDevice={
                                                    isMobileScreen
                                                }
                                                hasTag={e.isSponsor && e.services?.some(t => t.sponsorMessage)}
                                                onSelect={(checked) => {
                                                    if (checked) {
                                                        setSelectedRecords([
                                                            ...selectedRecords,
                                                            e,
                                                        ]);
                                                    } else {
                                                        setSelectedRecords(
                                                            selectedRecords.filter(
                                                                (f) =>
                                                                    f.firmID !==
                                                                    e.firmID,
                                                            ),
                                                        );
                                                    }
                                                }}
                                                key={index}
                                                data={e}
                                                checked={selectedRecords.some(
                                                    (f) =>
                                                        f.firmID ===
                                                        e.firmID,
                                                )}
                                                onSaveHistory={(e) => {
                                                    localStorage.setItem(KEY_ITEM_LOCALSTORAGE.REDIRECT_URL_COMPARE_SERVICE, window.location.href);
                                                }}
                                            />
                                        </>
                                    );
                                })} */}
                        </Card>
                    </div>
                </div >
            </Container >
        </MainComSearch >
        // </SearchServices >
    );
};

const CloseButton = (props: any) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={23}
            height={23}
            viewBox="0 0 23 23"
            fill="none"
            {...props}>
            <path
                d="M22.1471 19.1948C22.962 20.0106 22.962 21.3313 22.1471 22.1471C21.3313 22.962 20.0106 22.962 19.1948 22.1471L11.8367 14.7889C11.6507 14.602 11.3488 14.602 11.1628 14.7889L3.80466 22.1471C2.98887 22.962 1.66817 22.962 0.852378 22.1471C0.0374884 21.3313 0.0374884 20.0106 0.852378 19.1948L8.21054 11.8375C8.39741 11.6507 8.39741 11.3488 8.21054 11.1628L0.852378 3.80466C0.0374884 2.98887 0.0374884 1.66817 0.852378 0.852378C1.66817 0.0374884 2.98887 0.0374884 3.80466 0.852378L11.1628 8.21146C11.3488 8.39743 11.6507 8.39743 11.8367 8.21146L19.1948 0.852378C20.0106 0.0374884 21.3313 0.0374884 22.1471 0.852378C22.962 1.66817 22.962 2.98887 22.1471 3.80466L14.7889 11.1628C14.6021 11.3488 14.6021 11.6507 14.7889 11.8375L22.1471 19.1948Z"
                fill="#58585B"
            />
        </svg>
    );
};


